import React, {forwardRef, useEffect, useState} from 'react';
import Loader from 'react-loader-spinner';
import {formatPhoneNumber, getAppBasePath} from '../../utils/CommonUtility';
import store from "../../store";
import {chartConfig} from "../../AppConstants";
import CustomizedAccordions from "./CustomizedAccordions";
import ArrowToolTip from "./ArrowToolTip";

import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CCardHeader
} from '@coreui/react'

import {CChart} from '@coreui/react-chartjs'
import {v4 as uuidv4} from "uuid";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import Check from "@material-ui/icons/Check";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Edit from "@material-ui/icons/Edit";
import SaveAlt from "@material-ui/icons/SaveAlt";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import Search from "@material-ui/icons/Search";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Remove from "@material-ui/icons/Remove";
import ViewColumn from "@material-ui/icons/ViewColumn";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref}/>),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref}/>),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref}/>),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref}/>),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref}/>),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref}/>),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref}/>),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref}/>),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref}/>),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref}/>),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref}/>),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref}/>),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref}/>)
};

const Details = (props) => {

  const [appNumber, setAppNumber] = useState(null);
  const [userName, setUserName] = useState(null);
  const [loanState, setLoanState] = useState(null);
  const [loading, isLoading] = useState(false);
  const [leaseStatusViewData, setLeaseStatusViewData] = useState(false);

  const getChartData = () => {
    return ({
      datasets: [
        {
          data: leaseStatusViewData?.paymentScheduleInfo?.dataSetChart,
          backgroundColor: [
            '#1EDACB',
            '#EDECFE'
          ],
          hoverBackgroundColor: [
            '#1EDACB',
            '#EDECFE'
          ]
        }]
    });
  }

  const fetchLeaseStatusViewJSON = async (requestOptions) => {
    const response = await fetch(
      process.env.REACT_APP_LEASE_STATUS_VIEW_URL
      , requestOptions
      , {withCredentials: true}
    );

    let responseJSON = [];
    if (response.status !== 404) {
      responseJSON = await response.json();
    }
    return responseJSON;
  }

  const fetchData = (searchRequest) => {
    isLoading(true);

    let requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-request-id': uuidv4()
      },
      body: JSON.stringify(searchRequest)
    };

    console.log(`Request submitted with requestOptions: ${JSON.stringify(
      requestOptions)}`);

    fetchLeaseStatusViewJSON(requestOptions)
    .then(result => {
      setLeaseStatusViewData(result);
      isLoading(false);
    }, (error) => {
      console.log("Error from Request: ", error.message);
      isLoading(false);
    });
  }

  useEffect(() => {
    const detailsScreenFromStore = store.getState()?.detailsScreen;
    if (detailsScreenFromStore) {
      // display on Customer Section
      setAppNumber(detailsScreenFromStore.applicationNumber);
      setUserName(detailsScreenFromStore.lesseeName);
      setLoanState(detailsScreenFromStore.loanState);

      // set up request
      const {userId, loanApplicationId, loanId, outgoingPaymentId} = detailsScreenFromStore;
      let searchRequest = {
        'userId': userId,
        'loanApplicationId': loanApplicationId,
        'loanId': loanId,
        'outgoingPaymentId': outgoingPaymentId
      }

      if (store.getState()?.userSession == null
        || store.getState()?.userSession?.token == null) {
        window.location.replace(getAppBasePath());
      }
      fetchData(searchRequest);
    }
  }, []);

  return (
    <>
      <div className="pageTitle">Lease Information</div>
      <CRow className="col-sm-10">
        <CCol sm="4">
          <CCard className="detailCard">
            <CCardBody>
              <CRow>
                <CCol sm="6">
                  Lease Status
                </CCol>
                <CCol sm="1">
                  <div className={`${loanState}Status`}/>
                </CCol>
                <CCol sm="4">
                  <div> <span
                    className="leaseStatus">{loanState}</span></div>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardBody>
              <CRow>
                <CCol sm="11">
                  <div className="chart-wrapper">
                    {leaseStatusViewData?.paymentScheduleInfo &&
                    <CChart type="doughnut"
                            options={{
                              tooltips: {
                                enabled: true
                              }
                            }}
                            labels={chartConfig.labels}
                            datasets={getChartData().datasets}/>}
                  </div>
                </CCol>
              </CRow>
            </CCardBody>
            {leaseStatusViewData && <CustomizedAccordions
              leaseStatusViewData={leaseStatusViewData}/>}
          </CCard>
        </CCol>
        <CCol sm="8">
          {loading && <Loader type="ThreeDots" color="#A6A7AD" height={50}
                              width={50}/>}
          <CCard>
            <CCardHeader>
              Payment History
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  <MaterialTable icons={tableIcons}
                                 data={leaseStatusViewData.paymentHistories}
                                 columns={[
                                   {
                                     field: 'paymentType',
                                     title: 'Payment Type'
                                   },
                                   {
                                     field: 'paymentStatus',
                                     title: 'Payment Status'
                                   },
                                   {
                                     field: 'billedOn',
                                     title: 'Billed On'
                                   },
                                   {
                                     field: 'paidOn',
                                     title: 'Paid On'
                                   },
                                   {
                                     field: 'pin',
                                     title: 'PIN'
                                   },
                                   {
                                     field: 'paymentAmount',
                                     type: 'currency',
                                     title: 'Payment Amount'
                                   }
                                 ]}
                                 options={{
                                   search: true,
                                   paging: true,
                                   exportButton: false,
                                   showTitle: false,
                                   headerStyle: {
                                     maxWidth: 15,
                                     fontWeight: 'bold',
                                     fontSize: 12,
                                     height: 10,
                                     maxHeight: 10,
                                     textOverflow: "ellipsis",
                                     overflow: "hidden"
                                   },
                                   searchFieldStyle: {
                                     maxWidth: 200,
                                     fontSize: 10,
                                     height: 20,
                                     maxHeight: 20
                                   },
                                   cellStyle: {
                                     fontSize: 12,
                                     height: 10,
                                     maxHeight: 20,
                                     textTransform: "capitalize",
                                     textOverflow: "ellipsis",
                                     overflow: "hidden"
                                   }
                                 }}/>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <div className="detailSideDisplay col-sm-2">
        <div className="centeredText">
          <CRow>
            <CCol>
              <div className="customerInfoTitle">Application</div>
              <div className="customerInfo">{appNumber}</div>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <div className="customerInfoTitle">Name</div>
              <div className="customerInfo">{userName}</div>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <div className="customerInfoTitle">Address</div>
              {leaseStatusViewData.customerInfo
              && leaseStatusViewData.customerInfo.addressLines?.map(
                (addressLine) => <div className="addressLine"
                                      key={addressLine}>{addressLine}</div>)}
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <div className="customerInfoTitle">Phone</div>
              <div className="customerInfo">{leaseStatusViewData.customerInfo
              && formatPhoneNumber(
                leaseStatusViewData.customerInfo.phone)}</div>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <div className="customerInfoTitle">Email</div>
              {leaseStatusViewData?.customerInfo?.email && <ArrowToolTip
                toolTipData={{
                  text: leaseStatusViewData.customerInfo.email,
                  className: "customerEmail"
                }}/>}
            </CCol>
          </CRow>
        </div>
      </div>
    </>
  )
}
export default Details;
